<template>
  <div class="reviews__container">
    <div class="reviews__background">
      <img class="reviews__background-img" src="/images/features/common/reviews_background.png">
    </div>
    <div class="reviews__content">
      <div
        :class="['reviews__button', 'reviews__button-left']"
        @click="goToPrevSlide"
      >
        <Icon name="CaretLeft" />
      </div>
      <div class="reviews__head">
        <Comas />
        <Heading size="h4">
          {{ $t('pages.ssr_features.pages.common.reviews.title') }}
        </Heading>
      </div>

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(review, index) in reviews" :key="index" class="swiper-slide">
            <CustomText class="reviews__body-review">
              {{ review.review }}
            </CustomText>
            <CustomText weight="bold">
              {{ review.author }}
            </CustomText>
          </div>
        </div>
      </div>

      <div
        :class="['reviews__button', 'reviews__button-right']"
        @click="goToNextSlide"
      >
        <Icon name="CaretLeft" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Swiper } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import Comas from './svg/Comas'
import Heading from '@/components/common/Heading/Heading'
import Icon from '@/components/common/Icon/Icon'
import CustomText from '@/components/common/CustomText/CustomText'

export default {
  components: {
    Comas,
    Heading,
    Icon,
    CustomText
  },

  props: {
    reviews: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      swiper: null
    }
  },

  computed: {
    ...mapState('window', ['isMobile'])
  },

  mounted () {
    setTimeout(() => {
      this.swiper = new Swiper('.swiper-container', {
        loop: true,
        direction: 'horizontal',
        autoHeight: this.isMobile,
        navigation: {
          nextEl: '.reviews__button-right',
          prevEl: '.reviews__button-left'
        }
      })
    }, 300)
  },

  methods: {
    goToNextSlide () {
      this.swiper.slideNext()
    },

    goToPrevSlide () {
      this.swiper.slidePrev()
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-slide {
  transition: all .2s ease;
}

.reviews {
  &__container {
    position: relative;
    width: 100%;
    padding: $gap * 5;

    @include display-less(desktop) {
      padding: $gap * 5 $gap $gap * 9 $gap;
    }
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    &-img {
      height: 100%;
      width: 100%;
    }
  }

  &__content {
    position: relative;
    margin: 0 auto;
    max-width: 1120px;
    z-index: 1;
  }

  &__button {
    position: absolute;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 1px solid #f2f2f2;
    background-color: rgba(#ffffff, 0.15);
    width: 32px;
    height: 32px;
    cursor: pointer;

    @include display(desktop) {
      &:hover {
        background-color: rgba(#ffffff, 0.30);
      }
    }

    @include display-less(desktop) {
      top: unset;
      bottom: $gap * -5;
    }

    &-left {
      transform: translate(-100%, -50%);
      left: $gap * -1.5;

      @include display-less(desktop) {
        left: $gap * 2;
      }
    }

    &-right {
      transform: translate(-100%, 50%);
      rotate: 180deg;
      right: $gap * -1.5;

      @include display-less(desktop) {
        left: $gap * 2;
      }
    }
  }

  &__head {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $gap * 2;
    margin-bottom: $gap * 2;
  }

  &__body {
    &-review {
      font-size: 24px;
      line-height: 36px;
      margin-bottom: $gap * 2;
    }
  }
}
</style>
